export const alizarin = '#e74c3c';
export const peterRiver = '#3498db';
export const midnightBlue = '#2c3e50';
export const emerald = '#2ecc71';
export const wetAsphalt = '#34495e';
export const white = '#ffffff';
export const textBlack = '#424242';
export const secondaryTextBlack = '#666666';


// WEBPACK FOOTER //
// ./src/styles/colors.js